// src/utils/currency.js
export const getCurrencySymbol = (currency) => {
  switch (currency) {
    case "INR":
      return "₹";
    case "USD":
      return "$";
    case "EUR":
      return "€";
    default:
      return ""; // fallback if no currency provided
  }
};
